import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import HomeTabNavigator from "./HomeTabNavigator";
import ModalScreen from "../../../screens/ModalScreen";
import UserSettingsTabNavigator from "../../SharedNavigator/TabNavigator/UserSettingsTabNavigator";
import Colors from "../../../utils/constants/colors";
import useColorScheme from "../../../hooks/useColorScheme";
import { StyleSheet } from "react-native";
import { RootTabParamList, RootTabScreenProps } from "../../../types";
import HubspotSettingsTabNavigator from "../../SharedNavigator/TabNavigator/HubspotSettingsTabNavigator";
import { useTranslation } from "../../../utils/useTranslation";
import { useAppTheme } from "../../../hooks/useAppTheme";


export default function TopTabNavigator({ }) {
  const { colors } = useAppTheme();
  const colorScheme = useColorScheme();
  const Tab = createMaterialTopTabNavigator<RootTabParamList>();
  const { t } = useTranslation();

  return (
    <Tab.Navigator
      initialRouteName="Home"
      screenOptions={{
        headerTintColor: colors.text,
        headerStyle: {
          backgroundColor: colors.surface,
          borderBottomWidth: 1,
          borderBottomColor: colors.border,
        },
        headerTitleStyle: {
          color: colors.text,
        },
        tabBarStyle: {
          backgroundColor: colors.surface,
          borderTopColor: colors.border,
        },
        swipeEnabled: false,
        tabBarActiveTintColor: Colors[colorScheme].tint,
        tabBarIndicatorStyle: styles._tabBarIndicatorStyle,
        tabBarStyle: styles._tabBarStyle,
        tabBarLabelStyle: styles._tabBarLabelStyle,
        tabBarItemStyle: styles._tabBarItemStyle,
      }}
    >
      <Tab.Screen
        name="Home"
        component={HomeTabNavigator}
        options={({ }: RootTabScreenProps<"Home">) => ({
          title: t("home"),
          tabBarItemStyle: { display: "none" },
        })}
      />
      {process.env.NODE_ENV !== "production" && (
        <Tab.Screen
          name="Help"
          component={ModalScreen}
          options={{
            title: t("help"),
            tabBarItemStyle: { display: "none" },
          }}
          listeners={{
            tabPress: (e) => {
              // Prevent default action
            },
          }}
        />
      )}
      {/* 
      {process.env.NODE_ENV !== "production" && (
        <Tab.Screen
          name="UserSettings"
          component={UserSettingsTabNavigator}
          options={({ }: RootTabScreenProps<"UserSettings">) => ({
            title: t("accounts"),
          })}
          listeners={{
            tabPress: (e) => {
              // Prevent default action
            },
          }}
        />
      )}
      */}
      {process.env.NODE_ENV !== "production" && (
        <Tab.Screen
          name="HubspotSettings"
          component={HubspotSettingsTabNavigator}
          options={({ navigation }: RootTabScreenProps<"HubspotSettings">) => ({
            title: t("hubspot"),
            tabBarItemStyle: { display: "none" },
          })}
          listeners={{
            tabPress: (e) => {
              // Prevent default action
            },
          }}
        />
      )}
    </Tab.Navigator>
  );
}

const styles = StyleSheet.create({
  _tabBarIndicatorStyle: {
    backgroundColor: "transparent", // Make indicator transparent
    height: 0, // Remove indicator height
  },
  _tabBarStyle: {
    height: 60,
    width: 0,
    marginRight: "5%",
    alignSelf: "flex-end",
    // justifySelf: "center",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  _tabBarLabelStyle: {
    fontSize: 16,
    textTransform: "none",
  },
  _tabBarItemStyle: {
    width: 100,
  },
});
